import styled from "styled-components"
import { device } from "breakpoints"
import { Teaser } from "components/Teaser"
import AvenueLink from "components/AvenueLink"
import { getGradient } from "helpers/getGradient"
import { getGradientText } from "helpers/getGradientText"
import { getSolidColor } from "helpers/getSolidColor"
import { Carousel } from "components/Carousel"
import {
  Controls,
  Dots,
  Buttons,
  NextButton,
  PreviousButton,
  Slide,
  SlidesContainer,
  EmblaComponent,
} from "../Carousel/style"
import { Title, Excerpt, ImageWrapper } from "components/Teaser/style"

export const ReadMore = styled(AvenueLink)`
  font-weight: 600;
  font-size: 14px;
  color: black;
  text-transform: capitalize;
  margin-top: auto;
  span {
    position: relative;

    :after {
      content: "";
      position: absolute;
      height: 1px;
      width: 100%;
      bottom: -1px;
      left: 0;
      background-image: ${getGradient("live")};
      transition: 200ms;
    }
  }

  @media ${device.desktop} {
    font-size: 18px;
  }
`

export const TeaserCarouselContainer = styled.div`
  margin-bottom: 60px;
  position: relative;

  @media ${device.tablet} {
    margin-bottom: 70px;
  }

  @media ${device.desktop} {
    margin-bottom: 90px;
  }
  h2 {
    font-size: 42px;
    margin-bottom: 30px;
    ${props => getGradientText("live")}
    background-image: linear-gradient(-39deg, #399BA2 0%, #03A03F 100%);
    @media ${device.desktop} {
      font-size: 50px;
      margin-bottom: 45px;
    }

    @media ${device.large} {
      font-size: 60px;
      margin-bottom: 52px;
    }
  }
`

export const StandardTeaser = styled(Teaser)`
  height: 100%;
  padding-bottom: 2px;
  :hover {
    ${Title} {
      color: ${getSolidColor("live")};
    }
    ${ReadMore} {
      span:after {
        opacity: 0;
      }
    }
  }
  ${ImageWrapper} {
    padding-top: 72.2222%;
    margin-bottom: 26px;
  }

  ${Title} {
    color: black;
    font-size: 18px;
    position: relative;
    margin-bottom: 15px;
    @media ${device.tablet} {
      font-size: 21px;
    }
    @media ${device.desktop} {
      font-size: 24px;
      margin-bottom: 22px;
    }
  }

  ${Excerpt} {
    font-size: 14px;
    margin-bottom: 20px;
    padding-right: 5px;

    @media ${device.desktop} {
      margin-bottom: 25px;
      font-size: 18px;
    }
  }
`

export const ExtendedCarousel = styled(Carousel)`
 
  ${Controls} {
    flex-direction: row;
    align-self: flex-start;
    padding-left: 30px;
    margin-top: 40px;
    pointer-events:all;


    @media ${device.tablet} {
      width: ${props => `calc(100% - 2*${props.theme.desktopGutter}px)`};
      max-width: ${props => `${props.theme.mainMaxWidth}px`};
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      justify-content: flex-end;
      margin-top: 0;
    }
  }

  ${Buttons} {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    @media ${device.tablet} {
      position: static;
      left: auto;
      transform: none;
    }
  }

  ${NextButton} {
    /* background-image: ${getGradient("live")}; */
    background-image: linear-gradient(120deg, #78BE20 0%, #00AED9 100%);
    height: 42px;
    width: 42px;

    @media ${device.desktop} {
      height: 48px;
      width: 48px;
    }
  }

  ${PreviousButton} {
    margin-right: 10px;
  }

  ${Dots} {
    order: 0;
    margin-left: 5px;
    display: none;

    @media ${device.tablet} {
      margin-right: 15px;
      display: block;
    }
  }
`
